module.exports = {
	// 小程序 / APP请求配置





	// H5请求配置

	HTTP_REQUEST_URL: (location.hostname === 'localhost' || location.hostname === '127.0.0.1') 
	    ? 'https://www.beijiexing.cn' 
	    : window.location.protocol + '//' + window.location.host,

	//HTTP_REQUEST_URL: `https://www.beijiexing.cn`,
	//HTTP_REQUEST_URL: window.location.protocol + "//" + window.location.host,
	//HTTP_REQUEST_URL: location.hostname === `localhost`? `https://www.beijiexing.cn`:`${window.location.protocol}//${window.locatn.host}`,
	




	// 以下配置在不做二开的前提下,不需要做任何的修改
	HEADER: {
		'content-type': 'application/json',

		'Form-type': navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1 ? 'wechat' : 'h5',







	},
	// 回话密钥名称 请勿修改此配置
	TOKENNAME: 'Authori-zation',
	// 缓存时间 0 永久
	EXPIRE: 0,
	//分页最多显示条数
	LIMIT: 10,
	// 请求超时限制 默认10秒
	TIMEOUT: 10000
}